<ion-modal [isOpen]="isOpen" (didDismiss)="onDismiss()">
    <ng-template>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{'permissionModal.title' | translate}}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <div class="modal-content">
                <ion-icon name="notifications-outline" size="large" color="primary"></ion-icon>
                <h2>{{'permissionModal.stay_informed' | translate}}</h2>
                <p>{{'permissionModal.question' | translate}}</p>
                <div class="ion-margin-top">
                    <ion-button expand="block" (click)="allow()">{{'permissionModal.allow' | translate}}</ion-button>
                    <ion-button expand="block" fill="clear" (click)="close()">{{'permissionModal.later' | translate}}</ion-button>
                </div>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>
